import Box from '@mui/material/Box/Box'
import Typography from '@mui/material/Typography/Typography'
import format from 'date-fns/format'

import { i18WithParams as t, i18WithComponent as tc } from '@shared/locale'
import { ButtonActions } from 'components-ui/src/button_actions/button_actions'
import { SimpleModal } from 'components-ui/src/simple_modal/simple_modal'
import { Spacer } from 'components-ui/src/spacer/spacer'

interface Props {
  isOpen: boolean
  date?: Date
  onConfirm: () => void
  onClose: () => void
}

const Underline = () => {
  return (
    <Typography component="span" variant="body2bold" sx={{ textDecoration: 'underline' }}>
      {t('global.label.not')}
    </Typography>
  )
}

export const WaitlistModal = ({ isOpen, date, onConfirm, onClose }: Props) => {
  const dateStr = date ? format(date, 'MMM d') : ''

  return (
    <SimpleModal open={isOpen} onClose={onClose} sx={{ width: '500px', padding: '24px 24px 8px' }}>
      <Typography variant="h5">{t('datesSelection.waitlist.title', { date: dateStr })}</Typography>
      <Typography variant="body2bold" color="error">
        {tc('searchResults.waitlist.lead', { not: <Underline /> })}
      </Typography>
      <Typography variant="body1" mt={2}>
        {t('datesSelection.waitlist.lead')}
      </Typography>
      <Box sx={{ mt: 2, border: '1px solid ', borderColor: 'divider', borderRadius: 1, p: 2 }}>
        <Typography variant="body2bold">{t('datesSelection.waitlist.price1')}</Typography>
        <Typography variant="subtitle2" color="text.secondary">
          {t('datesSelection.waitlist.price2')}
        </Typography>
      </Box>
      <Spacer height={3} />
      <Box sx={{ display: 'flex', justifyContent: 'end', mb: 2 }}>
        <ButtonActions
          onActionLabel={t('datesSelection.waitlist.action')}
          onAction={async () => onConfirm()}
          onCancel={async () => onClose()}
        />
      </Box>
    </SimpleModal>
  )
}
